import React from "react";
import { FormFieldLabel } from "@components/common/FormField";
import { formFieldLabelClassName } from "@config/theme/formControls";
import type { MultiSelectLabelProps } from "../types/types";

export const MultiSelectLabel: React.FC<MultiSelectLabelProps> = ({
	label,
	required = false,
	id,
}) => {
	if (!label) return null;

	return (
		<FormFieldLabel
			htmlFor={id}
			required={required}
			className={`${formFieldLabelClassName} mb-1.5`}>
			{label}
		</FormFieldLabel>
	);
}; 